import { generateOverlayUid } from '@/packages/ev-overlays/registry';

export const TYPES = {
  portal: 1,
  form: 2,
};

export const TYPES_DATA = {
  [TYPES.portal]: {
    component: () => import('./components/drawers/DrawerPortal.vue'),
  },
  [TYPES.form]: {
    component: () => import('./components/drawers/DrawerForm.vue'),
  },
};

export const DRAWER_SLOTS = {
  close: 'close',
  main: 'main',
  card: 'card',
  title: 'title',
  subtitle: 'subtitle',
  content: 'content',
  actions: 'actions',
};

export class Drawer {
  constructor(options) {
    this.id = generateOverlayUid();
    this.state = true;
    this.type = options.type;
    this.attrs = { id: this.id, ...(options.attrs || {}) };
    this.listeners = options.listeners || {};
  }

  get component() {
    const { type } = this;
    return TYPES_DATA[type].component;
  }
}
